

const { Component } = wp.element;
import { Button, Dropdown, } from '@wordpress/components'
import { useState, } from '@wordpress/element'
import { applyFilters, doAction, addAction, addFilter } from "@wordpress/hooks";

import { __experimentalInputControl as InputControl, ColorPalette } from '@wordpress/components';



/*postTitle*/
addFilter('PPSFCElementHtmlpostTitle', 'ppsfc/element', PPSFCElementHtmlpostTitle, 10)

function PPSFCElementHtmlpostTitle(html, itemData, element) {


  var options = element?.options
  var linkTo = options?.linkTo
  var target = options?.target


  return <div id={`element-${element.id}`} className={`${element.type}`}>
    {linkTo?.length > 0 && (
      <a href={"#"} target={target} onClick={ev => {
        ev.preventDefault();
      }}
      >{itemData.postTitle.titleText}</a>
    )}
    {linkTo?.length == 0 && (
      <>{itemData.postTitle.titleText}</>
    )}




  </div>;
}

/*postId*/
addFilter('PPSFCElementHtmlpostId', 'ppsfc/element', PPSFCElementHtmlpostId, 10)

function PPSFCElementHtmlpostId(html, itemData, element) {


  var options = element?.options
  var linkTo = options?.linkTo
  var target = options?.target


  return <div id={`element-${element.id}`} className={`${element.type}`}>
    {linkTo?.length > 0 && (
      <a href={"#"} target={target} onClick={ev => {
        ev.preventDefault();
      }}>{itemData.ID}{itemData.postId.id}</a>
    )}
    {linkTo?.length == 0 && (
      <>{itemData.ID}{itemData.postId.id}</>
    )}




  </div>;
}


/*readMore*/
addFilter('PPSFCElementHtmlreadMore', 'ppsfc/element', PPSFCElementHtmlreadMore, 10)

function PPSFCElementHtmlreadMore(html, itemData, element) {

  var options = element.options
  var target = options?.target
  var readMoreText = options?.readMoreText


  return <a id={`element-${element.id}`} className={`${element.type}`} target={target} href={"#"} onClick={ev => {
    ev.preventDefault();
  }}>{readMoreText}</a>;
}
/*customText*/
addFilter('PPSFCElementHtmlcustomText', 'ppsfc/element', PPSFCElementHtmlcustomText, 10)

function PPSFCElementHtmlcustomText(html, itemData, element) {

  var options = element.options
  var content = options?.content
  var customTag = options?.customTag
  const CustomTagWrapper = `${customTag}`;


  return <CustomTagWrapper id={`element-${element.id}`} className={`${element.type}`} onClick={ev => {
    ev.preventDefault();
  }}>{content}</CustomTagWrapper>;
}











/*postExcerpt*/
addFilter('PPSFCElementHtmlpostExcerpt', 'ppsfc/element', PPSFCElementHtmlpostExcerpt, 10)

function PPSFCElementHtmlpostExcerpt(html, itemData, element) {

  var options = element.options;
  var limitBy = options?.limitBy;
  var limitCount = options?.limitCount;
  var target = options?.target;
  var readMoreText = options?.readMoreText


  var excerptText = itemData.postExcerpt.excerptText


  var count = limitCount > 0 ? limitCount : 999;
  if (limitBy == "character") {
    excerptText = excerptText.substring(0, count)
  } else if (limitBy == "word") {
    setPostExcerptEdited(
      excerptText = excerptText.split(" ").splice(0, count).join(" ")

    );
  }

  return <div id={`element-${element.id}`} className={`${element.type}`} >
    <p className="excerpt-text">
      {excerptText}
    </p>
    {readMoreText?.length > 0 && (
      <a href={"#"} target={target} className="redmore" onClick={ev => {
        ev.preventDefault();
      }}>{readMoreText}</a>
    )}

  </div>;
}

/*postDate*/
addFilter('PPSFCElementHtmlpostDate', 'ppsfc/element', PPSFCElementHtmlpostDate, 10)

function PPSFCElementHtmlpostDate(html, itemData, element) {

  var options = element.options;
  var prefixText = options?.prefixText;
  var postfixText = options?.postfixText;
  var linkTo = options?.linkTo;
  var target = options?.target;
  var format = options?.format;

  return <div id={`element-${element.id}`} className={`${element.type}`} >
    {prefixText?.length > 0 && (
      <div className="prefix">{prefixText}</div>
    )}


    {linkTo?.length > 0 && (
      <a href={"#"} target={target} className="post-date-label" onClick={ev => {
        ev.preventDefault();
      }}>{itemData.postDate.date}</a>
    )}
    {linkTo?.length == 0 && (
      <div className="post-date-label">{itemData.postDate.date}</div>
    )}

    {postfixText?.length > 0 && (
      <div className="prefix">{postfixText}</div>
    )}

  </div>;
}

/*postAuthor*/
addFilter('PPSFCElementHtmlpostAuthor', 'ppsfc/element', PPSFCElementHtmlpostAuthor, 10)

function PPSFCElementHtmlpostAuthor(html, itemData, element) {

  var options = element.options;
  var prefixText = options?.prefixText;
  var postfixText = options?.postfixText;
  var linkTo = options?.linkTo;
  var target = options?.target;


  return <div id={`element-${element.id}`} className={`${element.type}`} >

    <div className="prefix">{prefixText}</div>
    {linkTo?.length > 0 && (
      <a href={"#"} target={target} className="author-name" onClick={ev => {
        ev.preventDefault();
      }}>{itemData.postAuthor.authorName}</a>
    )}
    {linkTo?.length == 0 && (
      <div className="author-name">{itemData.postAuthor.authorName}</div>
    )}
    <div className="postfix">{postfixText}</div>
  </div>;
}

/*postAuthorAvatar*/
addFilter('PPSFCElementHtmlpostAuthorAvatar', 'ppsfc/element', PPSFCElementHtmlpostAuthorAvatar, 10)

function PPSFCElementHtmlpostAuthorAvatar(html, itemData, element) {

  var options = element.options;
  var prefixText = options.prefixText;
  var postfixText = options.postfixText;
  var linkTo = options.linkTo;
  var target = options.target;

  return <div id={`element-${element.id}`} className={`${element.type}`} >
    <div className="prefix">{prefixText}</div>

    {linkTo.length > 0 && (
      <a href={"#"} target={target} className="author-link" onClick={ev => {
        ev.preventDefault();
      }}>
        <img className="avatar" src={itemData.postAuthorAvatar.srcUrl} alt="" />
      </a>
    )}
    {linkTo.length == 0 && (
      <img className="avatar" src={itemData.postAuthorAvatar.srcUrl} alt="" />
    )}


    <div className="postfix">{postfixText}</div>

  </div>;
}

/*postCategories*/
addFilter('PPSFCElementHtmlpostCategories', 'ppsfc/element', PPSFCElementHtmlpostCategories, 10)

function PPSFCElementHtmlpostCategories(html, itemData, element) {

  var options = element.options
  var maxCount = options?.maxCount
  var prefixText = options?.prefixText
  var postfixText = options?.postfixText
  var target = options?.target
  var postCount = options?.postCount
  var separator = options?.separator

  var categories = [
    { title: 'Category 1', count: 123 },
    { title: 'Category 2', count: 124 },
    { title: 'Category 3', count: 125 },
    { title: 'Category 4', count: 126 },
    { title: 'Category 5', count: 127 },
  ];

  var MaxCategories = categories.slice(0, maxCount);


  return <div id={`element-${element.id}`} className={`${element.type}`} >
    <div className="prefix">{prefixText}</div>
    <div className="terms-items">
      {MaxCategories.map((category, index) => {
        return (
          <div className="term-item">
            <a className="term-link" href="#" target={target} onClick={ev => {
              ev.preventDefault();
            }}>
              <span className="term-title">{category.title}</span>
              {postCount && (
                <span className="post-count" >{`(${category.count})`}</span>
              )}
            </a>

            {MaxCategories.length > (index + 1) && (
              <span className="separator">{separator}</span>
            )}


          </div>
        )
      })}
    </div>
    <div className="postfix">{postfixText}</div>

  </div>;
}

/*postTags*/
addFilter('PPSFCElementHtmlpostTags', 'ppsfc/element', PPSFCElementHtmlpostTags, 10)

function PPSFCElementHtmlpostTags(html, itemData, element) {

  var options = element.options
  var maxCount = options?.maxCount
  var prefixText = options?.prefixText
  var postfixText = options?.postfixText
  var target = options?.target
  var postCount = options?.postCount
  var separator = options?.separator

  var tags = [
    { title: 'Tag 1', count: 123 },
    { title: 'Tag 2', count: 124 },
    { title: 'Tag 3', count: 125 },
    { title: 'Tag 4', count: 126 },
    { title: 'Tag 5', count: 127 },

  ];

  var MaxTags = tags.slice(0, maxCount);


  return <div id={`element-${element.id}`} className={`${element.type}`} >
    <div className="prefix">{prefixText}</div>
    <div className="terms-items">
      {MaxTags.map((tag, index) => {
        return (
          <div className="item">
            <a className="term-link" href="#" target={target} onClick={ev => {
              ev.preventDefault();
            }}>
              <span className="term-title">{tag.title}</span>
              {postCount && (
                <span className="post-count" >{`(${tag.count})`}</span>
              )}</a>

            {MaxTags.length > (index + 1) && (
              <span className="separator">{separator}</span>
            )}
          </div>
        )
      })}
    </div>
    <div className="postfix">{postfixText}</div>

  </div>;
}



/*commentsCount*/
addFilter('PPSFCElementHtmlcommentsCount', 'ppsfc/element', PPSFCElementHtmlcommentsCount, 10)

function PPSFCElementHtmlcommentsCount(html, itemData, element) {
  return <div id={`element-${element.id}`} className={`${element.type}`} >{itemData.commentsCount.count}</div>;
}

/*shareButton*/
addFilter('PPSFCElementHtmlshareButton', 'ppsfc/element', PPSFCElementHtmlshareButton, 10)

function PPSFCElementHtmlshareButton(html, itemData, element) {
  return <div id={`element-${element.id}`} className={`${element.type}`} >shareButton</div>;
}

/*postContent*/
addFilter('PPSFCElementHtmlpostContent', 'ppsfc/element', PPSFCElementHtmlpostContent, 10)

function PPSFCElementHtmlpostContent(html, itemData, element) {
  return <div id={`element-${element.id}`} className={`${element.type}`} >Affiliate marketers depend heavily on email marketing to drive sales and connect with leads. However, when email lists are not verified, they can lead to higher bounce rates, spam complaints, and even blacklisting by email providers. This section will introduce…

  </div>;
}

/*postThumbnail*/
addFilter('PPSFCElementHtmlpostThumbnail', 'ppsfc/element', PPSFCElementHtmlpostThumbnail, 10)

function PPSFCElementHtmlpostThumbnail(html, itemData, element) {

  var elementOptions = element.options;

  // console.log(itemData);
  // console.log(element);

  var srcUrl = itemData?.postThumbnail?.srcUrl ? itemData?.postThumbnail?.srcUrl : elementOptions?.defaultSrcUrl


  return <div id={`element-${element.id}`} className={`${element.type}`} >
    <img src={srcUrl} alt="" />
  </div>;
}

/*postMeta*/
addFilter('PPSFCElementHtmlpostMeta', 'ppsfc/element', PPSFCElementHtmlpostMeta, 10)

function PPSFCElementHtmlpostMeta(html, itemData, element) {
  return <div id={`element-${element.id}`} className={`${element.type}`} >Post Meta</div>;
}





















/*fcPrice*/
addFilter('PPSFCElementHtmlfcPrice', 'ppsfc/element', PPSFCElementHtmlfcPrice, 10)

function PPSFCElementHtmlfcPrice(html, itemData, element) {


  var options = element?.options
  var currencySymbole = options.currencySymbole
  var currencyPosition = options.currencyPosition
  var separatorText = options.separatorText
  var prefixText = options.prefixText
  var postfixText = options.postfixText


  return <div id={`element-${element.id}`} className={`${element.type}`}>
    {prefixText?.length > 0 && (
      <div className="prefix">{prefixText}</div>
    )}
    <div className="regular">
      <span className="currency">{currencySymbole}</span>
      <span className="price-value">123</span>
    </div>
    <div className="separator">{separatorText}</div>

    <div className="sale-price">
      <span className="currency">{currencySymbole}</span>
      <span className="price-value">250</span>
    </div>
    {postfixText?.length > 0 && (
      <div className="postfix">{postfixText}</div>

    )}
  </div>;
}

/*fcSaleBadge*/
addFilter('PPSFCElementHtmlfcSaleBadge', 'ppsfc/element', PPSFCElementHtmlfcSaleBadge, 10)

function PPSFCElementHtmlfcSaleBadge(html, itemData, element) {


  var options = element?.options
  var onSaleText = options.onSaleText
  var prefixText = options.prefixText
  var postfixText = options.postfixText


  return <div id={`element-${element.id}`} className={`${element.type}`}>
    {prefixText?.length > 0 && (
      <div className="prefix">{prefixText}</div>
    )}
    <div className="on-sale-badge">
      {onSaleText}
    </div>
    {postfixText?.length > 0 && (
      <div className="postfix">{postfixText}</div>

    )}
  </div>;
}

/*fcSKU*/
addFilter('PPSFCElementHtmlfcSKU', 'ppsfc/element', PPSFCElementHtmlfcSKU, 10)

function PPSFCElementHtmlfcSKU(html, itemData, element) {


  var options = element?.options
  var dafaultSKUText = options.dafaultSKUText
  var prefixText = options.prefixText
  var postfixText = options.postfixText


  return <div id={`element-${element.id}`} className={`${element.type}`}>
    {prefixText?.length > 0 && (
      <div className="prefix">{prefixText}</div>
    )}
    <div className="sku">
      {dafaultSKUText}
    </div>
    {postfixText?.length > 0 && (
      <div className="postfix">{postfixText}</div>

    )}

  </div>;
}

/*fcStockQuantity*/
addFilter('PPSFCElementHtmlfcStockQuantity', 'ppsfc/element', PPSFCElementHtmlfcStockQuantity, 10)

function PPSFCElementHtmlfcStockQuantity(html, itemData, element) {


  var options = element?.options
  var dafultQuantity = options.dafultQuantity
  var prefixText = options.prefixText
  var postfixText = options.postfixText


  return <div id={`element-${element.id}`} className={`${element.type}`}>
    {prefixText?.length > 0 && (
      <div className="prefix">{prefixText}</div>
    )}
    <div className="stock-quantity">
      {dafultQuantity}
    </div>
    {postfixText?.length > 0 && (
      <div className="postfix">{postfixText}</div>

    )}


  </div>;
}

/*fcInStock*/
addFilter('PPSFCElementHtmlfcInStock', 'ppsfc/element', PPSFCElementHtmlfcInStock, 10)

function PPSFCElementHtmlfcInStock(html, itemData, element) {


  var options = element?.options
  var inStockText = options.inStockText
  var outOfStockText = options.outOfStockText
  var backOrderText = options.backOrderText
  var prefixText = options.prefixText
  var postfixText = options.postfixText
  var previewFor = options.previewFor


  return <div id={`element-${element.id}`} className={`${element.type}`}>
    {prefixText?.length > 0 && (
      <div className="prefix">{prefixText}</div>
    )}

    {previewFor == 'inStockText' && (
      <div className="instock">
        {inStockText}
      </div>
    )}
    {previewFor == 'outOfStockText' && (
      <div className="outofstock">
        {inStockText}
      </div>
    )}
    {previewFor == 'backOrderText' && (
      <div className="onbackorder">
        {inStockText}
      </div>
    )}


    {postfixText?.length > 0 && (
      <div className="postfix">{postfixText}</div>

    )}

  </div>;
}

/*fcTotalSales*/
addFilter('PPSFCElementHtmlfcTotalSales', 'ppsfc/element', PPSFCElementHtmlfcTotalSales, 10)

function PPSFCElementHtmlfcTotalSales(html, itemData, element) {


  var options = element?.options
  var defaultSaleCount = options.defaultSaleCount
  var prefixText = options.prefixText
  var postfixText = options.postfixText


  return <div id={`element-${element.id}`} className={`${element.type}`}>
    {prefixText?.length > 0 && (
      <div className="prefix">{prefixText}</div>
    )}
    <div className="sale-count">
      {defaultSaleCount}
    </div>
    {postfixText?.length > 0 && (
      <div className="postfix">{postfixText}</div>

    )}

  </div>;
}

/*fcProductRatings*/
addFilter('PPSFCElementHtmlfcProductRatings', 'ppsfc/element', PPSFCElementHtmlfcProductRatings, 10)

function PPSFCElementHtmlfcProductRatings(html, itemData, element) {


  var options = element?.options
  var iconsIdle = options.iconsIdle
  var iconsFilled = options.iconsFilled
  var defaultRating = options.defaultRating
  var summaryType = options.summaryType
  var summaryTypeCustom = options.summaryTypeCustom
  var summaryLinkTo = options.summaryLinkTo
  var prefixText = options.prefixText
  var postfixText = options.postfixText


  var iconsIdleHtml = `<span class="${iconsIdle.iconSrc}"></span>`;
  var iconsFilledHtml = `<span class="${iconsFilled.iconSrc}"></span>`;

  function replaceAll(str, correction) {
    Object.keys(correction).forEach((key) => {
      str = str.replaceAll(key, correction[key]);
    });
    return str;
  }

  var map = {
    "{rating_count}": "",
    "{review_count}": "",
    "{average_rating}": "",
    "{product_title}": "",
  };

  const [ratingMap, setratingMap] = useState(map);
  var filledStyles = { width: "60%" }


  return <div id={`element-${element.id}`} className={`${element.type}`}>
    {prefixText?.length > 0 && (
      <div className="prefix">{prefixText}</div>
    )}
    <div className="icons-wrap">
      <div className="icons-idle">
        <span
          className={``}
          dangerouslySetInnerHTML={{ __html: iconsIdleHtml }}
        />
        <span
          className={``}
          dangerouslySetInnerHTML={{ __html: iconsIdleHtml }}
        />
        <span
          className={``}
          dangerouslySetInnerHTML={{ __html: iconsIdleHtml }}
        />
        <span
          className={``}
          dangerouslySetInnerHTML={{ __html: iconsIdleHtml }}
        />
        <span
          className={``}
          dangerouslySetInnerHTML={{ __html: iconsIdleHtml }}
        />
        <div className="icons-filled" style={filledStyles}>
          <span
            className={``}
            dangerouslySetInnerHTML={{ __html: iconsFilledHtml }}
          />
          <span
            className={``}
            dangerouslySetInnerHTML={{ __html: iconsFilledHtml }}
          />
          <span
            className={``}
            dangerouslySetInnerHTML={{ __html: iconsFilledHtml }}
          />
          <span
            className={``}
            dangerouslySetInnerHTML={{ __html: iconsFilledHtml }}
          />
          <span
            className={``}
            dangerouslySetInnerHTML={{ __html: iconsFilledHtml }}
          />
        </div>
      </div>
    </div>
    <div className="summary">
      {summaryType !== "custom" &&
        summaryType !== null && (
          <>{replaceAll(summaryType, ratingMap)}</>
        )}
      {summaryType == "custom" &&
        summaryTypeCustom.length > 0 && (
          <>{replaceAll(summaryTypeCustom, ratingMap)}</>
        )}
    </div>
    {postfixText?.length > 0 && (
      <div className="postfix">{postfixText}</div>

    )}

  </div>;
}





/*fcAddToCart*/
addFilter('PPSFCElementHtmlfcAddToCart', 'ppsfc/element', PPSFCElementHtmlfcAddToCart, 10)

function PPSFCElementHtmlfcAddToCart(html, itemData, element) {


  var options = element?.options
  var addToCartText = options.addToCartText
  var quantityEnable = options.quantityEnable
  var icon = options.icon
  var iconPosition = options.iconPosition
  var prefixText = options.prefixText
  var postfixText = options.postfixText

  var iconSrc = icon?.iconSrc;


  var iconHtml = `<span class="${iconSrc}"></span>`;


  return <div id={`element-${element.id}`} className={`${element.type}`}>
    {iconPosition == "beforePrefix" && (
      <span
        className={`icon-wrap`}
        dangerouslySetInnerHTML={{ __html: iconHtml }}
      />
    )}
    {prefixText?.length > 0 && (
      <div className="prefix">{prefixText}</div>
    )}
    {iconPosition == "afterPrefix" && (
      <span
        className={`icon-wrap`}
        dangerouslySetInnerHTML={{ __html: iconHtml }}
      />
    )}
    <a
      className="cartBtn"
      onClick={ev => { ev.preventDefault() }}
      href="?add-to-cart=1399"
      data-quantity="1"
      data-product_id="1399"
      data-product_sku="fc-polo"
      aria-label="Add “Polo” to your cart"
      aria-describedby=""
      rel="nofollow">
      {iconPosition == "beforeCartText" && (
        <span
          className="icon-wrap"
          dangerouslySetInnerHTML={{ __html: iconHtml }}
        />
      )}
      {addToCartText}
      {iconPosition == "afterCartText" && (
        <span
          className="icon-wrap"
          dangerouslySetInnerHTML={{ __html: iconHtml }}
        />
      )}
    </a>
    {quantityEnable && (
      <div className='quantityWrap'>
        <div className="quantityIncrease">+</div>
        <input size="3"
          type="text"
          inputMode="numeric" className="quantityInput"
          placeholder='1'
          value={'3'}
        />
        <div className="quantityDecrease">-</div>
      </div>
    )}

    {iconPosition == "beforePostfix" && (
      <span
        className={`icon-wrap`}
        dangerouslySetInnerHTML={{ __html: iconHtml }}
      />
    )}
    {postfixText?.length > 0 && (
      <div className="postfix">{postfixText}</div>

    )}
    {iconPosition == "afterPostfix" && (
      <span
        className={`icon-wrap`}
        dangerouslySetInnerHTML={{ __html: iconHtml }}
      />
    )}

  </div>;
}
